<template>
  <div>
    <OneBoxDefault
      :dev-domains="devDomains"
      :area-list-title="'日本各地の天気予報'"
      :bread-crumb-list="breadCrumbList"
      :invisible-contents="invisibleContents"
      :is-web-view-prop="isWebViewFlag"
    >
      <slot name="main" />

      <template #main-bottom>
        <slot name="main-bottom" />
      </template>

      <template #ads-btf>
        <div
          v-if="!isWebViewFlag"
          id="ads-btf1-pc"
          class="ads-btf1-pc"
        />
        <div
          v-if="!isWebViewFlag"
          id="ads-btf3-sp"
          class="ads-btf3-sp"
        />
        <div v-else />
      </template>

      <template #ads-btf3>
        <!-- 防災・減災メニューの下(PCはbtf3, SPはbtf5) -->
        <div
          id="ads-btf3-pc"
          class="ads-btf3-pc"
        />
        <div
          id="ads-btf5-sp"
          class="ads-btf5-sp"
        />
      </template>

      <template #ads-btf5>
        <!-- お天気ニュースの下(PCのみ)  -->
        <div
          v-if="!isWebViewFlag"
          id="ads-btf5-pc"
          class="ads-btf5-pc"
        />
      </template>

      <template #ads-btf4>
        <!-- メニューの上(SPのみ)  -->
        <div
          v-if="!isWebViewFlag"
          id="ads-btf4-sp"
          class="ads-btf4-sp"
        />
      </template>
    </OneBoxDefault>
    <StickyAd />
  </div>
</template>

<script setup>
import { OneBoxDefault } from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/index'

const runtimeConfig = useRuntimeConfig()
const EnvDevDomains = runtimeConfig.public.devdomains
const devDomains = EnvDevDomains ? JSON.parse(EnvDevDomains) : null

const { $ads: ads } = useNuxtApp()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const invisibleContents = isWebViewFlag ? ['amedas', 'arealist', 'news', 'sidemenu'] : []

defineProps({
  breadCrumbList: {
    type: Array,
    default: () => ([])
  }
})

onMounted(() => {
  ads.init(getAdConfig(isWebViewFlag ? 'app' : 'web'))
})
</script>

<style scoped>
.ads-btf1-pc {
  min-height: 250px;
}

.ads-btf3-pc {
  min-height: 50px;
  margin: 15px auto 5px;
}

.ads-btf3-sp {
  min-height: 50px;
  margin: 15px auto 5px;
}

.ads-btf5-sp {
  min-height: 50px;
  margin: 15px auto 5px;
  text-align: center;
}

.ads-btf5-pc {
  min-height: 50px;
  margin: 0 auto 5px;
}

.ads-btf4-sp {
  min-height: 50px;
  margin: 0 auto 5px;
}
</style>
